<template>
  <Layout title="Meetings" description="Schedule, manage, and track your weekly meetings in one place.">
  

    <div class="d-flex justify-content-end mb-3">
      <button class="btn btn-primary" @click="showAdd = true">
        Add Meeting
      </button>
    </div>
  <vue-cal
  ref="cal"
  style="height: 500px"
  default-view="week"
  :events="events"
  :disable-views="['years','year','month','day']"
  @view-change="onViewChange"
  @event-click="openEdit"
>
  <!-- Click the event block to inspect it -->
  <template #event="{ event }">
    <div class="p-1"  :style="{
      background: event.clientId ? '#ADD8E6' : '#fff',
      color: event.clientId ? '#000' : '#333'
    }">
      <div class="fw-semibold text-truncate">{{ event.title }}</div>
      <div class="small text-muted text-truncate" v-if="event.clientId">
        with {{ idToCustomerName(event.clientId) }}
      </div>
    </div>
  </template>
</vue-cal>



  <div class="modal fade" tabindex="-1" :class="{ show: showAdd }" style="display:block" v-if="showAdd">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Add Meeting</h5>
          <button type="button" class="btn-close" @click="showAdd=false"></button>
        </div>

        <div class="modal-body">
          <form @submit.prevent="submitMeeting">
            <div class="mb-3">
              <label class="form-label">Title</label>
              <input v-model.trim="meetingForm.title" type="text" class="form-control" required />
            </div>

            <div class="mb-3">
              <label class="form-label">Description</label>
              <textarea v-model.trim="meetingForm.description" class="form-control" rows="3" placeholder="Agenda, notes, etc."></textarea>
            </div>

            <div class="row">
              <div class="col-md-6 mb-3">
                <label class="form-label">Start Time</label>
                <input v-model="meetingForm.start" type="datetime-local" class="form-control" required />
              </div>
              <div class="col-md-6 mb-3">
                <label class="form-label">End Time</label>
                <input v-model="meetingForm.end" type="datetime-local" class="form-control" :min="meetingForm.start" required />
              </div>
            </div>

            <div class="mb-3">
              <label class="form-label">Client</label>
              <select v-model="meetingForm.clientId" class="form-select" required>
                <option disabled value="">Select a client</option>
                <!-- v-for over dict of companies -->
                <option
                  v-for="(company, id) in customerList"
                  :key="id"
                  :value="company.id">
                  {{ company.name }} <span v-if="company.industry">— {{ company.industry }}</span>
                </option>
              </select>
            </div>

            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" @click="showAdd=false">Cancel</button>
              <button type="submit" class="btn btn-primary" :disabled="saving">
                <span v-if="!saving">Save Meeting</span>
                <span v-else class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              </button>
            </div>
          </form>
        </div>

      </div>
    </div>
  </div>
  <div class="modal fade" tabindex="-1" :class="{ show: showEdit }" style="display:block" v-if="showEdit">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Edit Meeting</h5>
          <button type="button" class="btn-close" @click="closeEdit"></button>
        </div>

        <div class="modal-body">
          <form @submit.prevent="submitEdit">
            <div class="mb-3">
              <label class="form-label">Title</label>
              <input v-model.trim="editForm.title" type="text" class="form-control" required />
            </div>

            <div class="mb-3">
              <label class="form-label">Description</label>
              <textarea v-model.trim="editForm.description" class="form-control" rows="3" placeholder="Agenda, notes, etc."></textarea>
            </div>

            <div class="row">
              <div class="col-md-6 mb-3">
                <label class="form-label">Start Time</label>
                <input v-model="editForm.start" type="datetime-local" class="form-control" required />
              </div>
              <div class="col-md-6 mb-3">
                <label class="form-label">End Time</label>
                <input v-model="editForm.end" type="datetime-local" class="form-control" :min="editForm.start" required />
              </div>
            </div>

            <div class="mb-3">
              <label class="form-label">Client</label>
              <select v-model="editForm.clientId" class="form-select" required>
                <option disabled value="">Select a client</option>
                <option
                  v-for="(company, id) in customerList"
                  :key="id"
                  :value="company.id">
                  {{ company.name }} <span v-if="company.industry">— {{ company.industry }}</span>
                </option>
              </select>
            </div>

            <div class="mb-3">
              <label class="form-label">Meeting Logs</label>
              <textarea v-model.trim="editForm.logs" class="form-control" rows="3" placeholder="Things to note"></textarea>
            </div>

            <div class="modal-footer">
              <button type="button" class="btn btn-outline-danger me-auto" @click="deleteMeeting" :disabled="savingDel">
                <span v-if="!savingDel">Delete</span>
                <span v-else class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              </button>

              <button type="button" class="btn btn-secondary" @click="closeEdit">Cancel</button>
              <button type="submit" class="btn btn-primary" :disabled="savingEdit">
                <span v-if="!savingEdit">Save Changes</span>
                <span v-else class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              </button>
            </div>
          </form>
        </div>

      </div>
    </div>
  </div>
  </Layout>

</template>

<script>
import VueCal from 'vue-cal'
import 'vue-cal/dist/vuecal.css'
import Layout from '@/components/Layout.vue';
import { useToast } from 'vue-toastification'
import { getAuth, onAuthStateChanged } from "firebase/auth";
import router from "@/router";
import axios from "axios";
// import { Building2,UserRound,NotebookTabs,Globe,Mail,MapPin,Sparkles,UserStar,Video, Trash2, Heart, X} from 'lucide-vue-next';

export default {
  components: { VueCal,Layout },
  data() {
    return {
      events: [],
      customerList:[],
      showAdd:false,
      showEdit:false,
      savingEdit:false,
      savingDel:false,
      meetingForm: {
        title: '',
        description: '',
        start: '',
        end: '',
        clientId: '',
        userID:''
      },
      editForm: {
        id: '',
        title: '',
        description: '',
        start: '',
        end: '',
        clientId: '',
        logs:""
      },
      // apiURL: "http://127.0.0.1:5001",
      apiURL: "https://genstoryflow-backend-main-build-353838813175.europe-west1.run.app",
      saving:false
    }
  }, 
  setup() {
    const toast = useToast();
    return { toast };
  },
  async mounted(){
    this.userID = this.$store.getters.getUserId;
      await this.checkAuthState();
      await this.loadCustomers();
      await this.initCalendarFetch(); 
  },
  methods: {
    async deleteMeeting() {
      if (!this.editForm.id) {
        this.toast.error('No meeting ID — cannot delete.');
        return;
      }

      this.savingDel = true;
      try {
        const headers = await this.getAuthHeader();
        await axios.delete(`${this.apiURL}/api/meetings/${this.editForm.id}`, { headers });

        // Optimistic remove from local list
        const idx = Number.isInteger(this.editingIndex) ? this.editingIndex
                  : this.events.findIndex(e => e.id === this.editForm.id);
        if (idx > -1) this.events.splice(idx, 1);

        // Refresh current calendar range to be safe
        const start = this.$refs.cal.view.startDate;
        const end   = this.$refs.cal.view.endDate;
        if (start && end && this.fetchMeetingsForRange) {
          await this.fetchMeetingsForRange(start, end);
        }

        this.toast.success('Meeting deleted.');
        this.closeEdit();
      } catch (e) {
        this.toast.error('Delete failed');
        console.error(e);
      } finally {
        this.savingDel = false;
      }
    },
    async submitEdit() {
      // validate
      if (new Date(this.editForm.end) <= new Date(this.editForm.start)) {
        this.toast.error('End Time must be after Start Time lah.');
        return;
      }
      if (!this.editForm.clientId) {
        this.toast.error('Choose a client first.');
        return;
      }
      if (!this.editForm.id) {
        this.toast.error('Update Fail');
        return;
      }

      this.savingEdit = true;
      try {
        const headers = await this.getAuthHeader();

        // inline converters (keep code lean)
        const toISO = (dLike) => {
          const d = (dLike instanceof Date) ? dLike : new Date(dLike);
          const pad = (n) => String(Math.floor(Math.abs(n))).padStart(2, '0');
          const y=d.getFullYear(), M=pad(d.getMonth()+1), D=pad(d.getDate()),
                H=pad(d.getHours()), I=pad(d.getMinutes()), S=pad(d.getSeconds());
          const offMin = -d.getTimezoneOffset();    // +480 for SG
          const sign = offMin >= 0 ? '+' : '-';
          const oh = pad(offMin/60), om = pad(offMin%60);
          return `${y}-${M}-${D}T${H}:${I}:${S}${sign}${oh}:${om}`;
        };
        const localDTtoISO = (localStr) => {
          const [dpart, tpart='00:00'] = String(localStr).split('T');
          const [y,m,d] = dpart.split('-').map(Number);
          const [hh,mm='0',ss='0'] = tpart.split(':');
          const dt = new Date(y, (m||1)-1, d||1, Number(hh)||0, Number(mm)||0, Number(ss)||0);
          return toISO(dt);
        };

        const payload = {
          title: this.editForm.title.trim(),
          desc: (this.editForm.description || '').trim(),
          user: this.editForm.clientId,                       // backend expects "user"
          startTime: localDTtoISO(this.editForm.start),
          endTime:   localDTtoISO(this.editForm.end),
          logs: (this.editForm.logs || '')
        };

        await axios.put(
          `${this.apiURL}/api/update-meeting/${this.editForm.id}`,
          payload,
          { headers }
        );

        // refresh current calendar view
        const start = this.$refs.cal.view.startDate;
        const end   = this.$refs.cal.view.endDate;
        if (start && end && this.fetchMeetingsForRange) {
          await this.fetchMeetingsForRange(start, end);
        }

        this.toast.success('Meeting updated!');
        this.editForm= {
              id: '',
              title: '',
              description: '',
              start: '',
              end: '',
              clientId: '',
              logs:""
            }
        this.closeEdit();
      } catch (e) {
        
          this.toast.error('Update failed:'+e);

      } finally {
        this.savingEdit = false;
        this.showEdit = false;
      }
    },
    idToCustomerName(id) {
      const rec = (this.customerList || []).find(c => c.id === id);
      return rec ? rec.name : '';
    },
    // ===== FETCH (range) =====
    async initCalendarFetch() {
      // Try using vue-cal visible range; else inline fallback to current week
      let start, end;
      if (this.$refs.cal.view.startDate && this.$refs.cal.view.endDate) {
        start = this.$refs.cal.view.startDate;
        end   = this.$refs.cal.view.endDate; // end exclusive
      } else {
        const today = new Date();
        const day = (today.getDay() + 6) % 7;       // Mon=0
        start = new Date(today); start.setHours(0,0,0,0); start.setDate(today.getDate() - day);
        end   = new Date(start); end.setDate(start.getDate() + 7); // next Mon 00:00
      }
      await this.fetchMeetingsForRange(start, end);
    },

    async onViewChange(payload) {
      const start = payload.startDate ;
      const end   = payload.endDate;
      await this.fetchMeetingsForRange(start, end);
    },

    async fetchMeetingsForRange(startDate, endDate) {
      this.loadingEvents = true;
      try {
        const headers = await this.getAuthHeader();

        // Inline ISO with local offset (+08:00 in SG)
        const toISO = (dateLike) => {
          const d = (dateLike instanceof Date) ? dateLike : new Date(dateLike);
          const pad = (n) => String(Math.floor(Math.abs(n))).padStart(2, '0');
          const y=d.getFullYear(), M=pad(d.getMonth()+1), D=pad(d.getDate()),
                H=pad(d.getHours()), I=pad(d.getMinutes()), S=pad(d.getSeconds());
          const offMin = -d.getTimezoneOffset(); // +480 for SG
          const sign = offMin >= 0 ? '+' : '-';
          const oh = pad(offMin/60), om = pad(offMin%60);
          return `${y}-${M}-${D}T${H}:${I}:${S}${sign}${oh}:${om}`;
        };

        const params = { start: toISO(startDate), end: toISO(endDate) };
        const res = await axios.get(`${this.apiURL}/api/meetings-by-date`, { params, headers });
        const list = Array.isArray(res.data) ? res.data : (res.data.meetings || []);
        this.events = list.map(this.mapMeetingToEvent);
        console.log(this.events)
      } catch (e) {
        console.error(e);
        this.toast.error('Cannot load meetings.');
      } finally {
        this.loadingEvents = false;
      }
    },

    mapMeetingToEvent(m) {
      // backend: id, title, description, clientId, startTime, endTime (ISO)
      return {
        id: m.id,
        title: m.title || 'Meeting',
        description: m.description || '',
        clientId: m.clientId || '',
        start: this.toVueCalFromISO(m.startTime),
        end:   this.toVueCalFromISO(m.endTime),
        background: '#ADD8E6', // light blue
        color: '#000',
        logs: m.logs
      };
    },

    // ===== ADD MEETING =====
    async submitMeeting() {
      if (new Date(this.meetingForm.end) <= new Date(this.meetingForm.start)) {
        this.toast.error('End Time must be after Start Time lah.');
        return;
      }
      if (!this.meetingForm.clientId) {
        this.toast.error('Choose a client first.');
        return;
      }

      this.saving = true;
      try {
        const headers = await this.getAuthHeader();

        // Inline converters to avoid extra helpers
        const toISO = (dateLike) => {
          const d = (dateLike instanceof Date) ? dateLike : new Date(dateLike);
          const pad = (n) => String(Math.floor(Math.abs(n))).padStart(2, '0');
          const y=d.getFullYear(), M=pad(d.getMonth()+1), D=pad(d.getDate()),
                H=pad(d.getHours()), I=pad(d.getMinutes()), S=pad(d.getSeconds());
          const offMin = -d.getTimezoneOffset();
          const sign = offMin >= 0 ? '+' : '-';
          const oh = pad(offMin/60), om = pad(offMin%60);
          return `${y}-${M}-${D}T${H}:${I}:${S}${sign}${oh}:${om}`;
        };
        const localDTtoISO = (localStr) => {
          // Accept 'YYYY-MM-DDTHH:mm'
          const [dpart, tpart='00:00'] = String(localStr).split('T');
          const [y,m,d] = dpart.split('-').map(Number);
          const [hh,mm='0',ss='0'] = tpart.split(':');
          const dt = new Date(y, (m||1)-1, d||1, Number(hh)||0, Number(mm)||0, Number(ss)||0);
          return toISO(dt);
        };

        const payload = {
          title: this.meetingForm.title.trim(),
          desc: (this.meetingForm.description || '').trim(),
          user: this.meetingForm.clientId,
          startTime: localDTtoISO(this.meetingForm.start),
          endTime:   localDTtoISO(this.meetingForm.end),
          userID: this.userID
        };

        await axios.post(`${this.apiURL}/api/add-meeting`, payload, { headers });

        // refresh current view
        const start = this.$refs.cal.view.startDate;
        const end   = this.$refs.cal.view.endDate;
        if (start && end) await this.fetchMeetingsForRange(start, end);

        this.toast.success('Meeting added!');
        this.showAdd=false
        this.meetingForm={
              title: '',
              description: '',
              start: '',
              end: '',
              clientId: '',
              userID:''
            }
      } catch (e) {
          this.toast.error('Cannot save meeting, try again.');
          console.error(e);
      } finally {
        this.saving = false;
        this.showAdd=false
      }
    },

    // ===== EDIT MODAL OPEN (no extra helpers) =====
    openEdit(payloadOrEvent) {
      let ev;
      if (payloadOrEvent && typeof payloadOrEvent === 'object' && 'event' in payloadOrEvent) ev = payloadOrEvent.event;
      else ev = payloadOrEvent;
      if (!ev) return;

      // Prefer id match; fallback to title+start string (convert Date -> "YYYY-MM-DD HH:mm")
      const evStartStr = this.toVueCalFromISO(ev.start);
      const idx = this.events.findIndex(x =>
        (ev.id && x.id === ev.id) || (!ev.id && x.title === ev.title && x.start === evStartStr)
      );
      if (idx === -1) return;

      const curr = this.events[idx];
      this.editingIndex = idx;

      // Convert event.start ("YYYY-MM-DD HH:mm" or Date) → datetime-local
      const normToInput = (v) => {
        const d = (v instanceof Date) ? v : new Date(typeof v === 'string' ? v.replace(' ', 'T') : v);
        return this.formatLocal(d);
      };

      this.editForm = {
        id: curr.id || '',
        title: curr.title || '',
        description: curr.description || '',
        start: normToInput(curr.start),
        end:   normToInput(curr.end),
        clientId: curr.clientId || '',
        logs: curr.logs
      };

      this.showEdit = true;
    },

    closeEdit() {
      this.showEdit = false;
      this.editingIndex = null;
      this.savingEdit = false;
      this.savingDel = false;
    },

    // ===== Utils kept =====
    toVueCalFromISO(v) {
      const d = (v instanceof Date) ? v : new Date(v);
      const pad = (n) => String(n).padStart(2, '0');
      return `${d.getFullYear()}-${pad(d.getMonth()+1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
    },

    formatLocal(d) {
      const pad = (n) => String(n).padStart(2, '0');
      return `${d.getFullYear()}-${pad(d.getMonth()+1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
    },

    // keep your auth + customers
    async checkAuthState() {
            const auth = getAuth();
            return new Promise((resolve, reject) => {
            onAuthStateChanged(auth, async (user) => {
                if (user) {
                try {
                    const idToken = await user.getIdToken();
                    this.token = idToken;
                    resolve(); // 🔥 Only resolve when token is ready
                } catch (error) {
                    reject(error);
                }
                } else {
                router.push("/");
                reject(new Error("No user logged in"));
                }
            });
            });
      },
      async loadCustomers() {
        try {
          const headers = await this.getAuthHeader();

          const res = await axios.get(`${this.apiURL}/getAllCompanies`, {
            params: { userID: this.userID },
            headers
          });

          this.customerList = res.data.data;
        } catch (err) {
          this.toast.error("Error Fetching")
          // console.error("❌ Failed to load customers:", err.message);
        }
      },
    async getAuthHeader() {
      const user = getAuth().currentUser;
      if (!user) throw new Error('Not logged in');

      const token = await user.getIdToken(); // 🔐 always fresh
      return {
        Authorization: token
      };
    },


  }

}
</script>

<style>
/* hide the view buttons (Day/Week/Month/Year) */
.vuecal__view-btn {
  display: none !important;
}
</style>
